export default "__VITE_ASSET__C_jEv3ke__"